import get from 'lodash/get';
import { updatePincodeAction } from 'actions/pincodeActions';
import ApiCaller from '../ApiCaller';
import baseAjaxConfig from '../BaseAjaxConfig';
import { CartView } from '@rome/request/cart/v5/CartView';
export var GET_CART_DETAILS;
(function (GET_CART_DETAILS) {
    GET_CART_DETAILS["REQUEST"] = "GET_CART_DETAILS_REQUEST";
    GET_CART_DETAILS["SUCCESS"] = "GET_CART_DETAILS_SUCCESS";
    GET_CART_DETAILS["ERROR"] = "GET_CART_DETAILS_ERROR";
})(GET_CART_DETAILS || (GET_CART_DETAILS = {}));
export var GET_BASKET_DETAILS;
(function (GET_BASKET_DETAILS) {
    GET_BASKET_DETAILS["REQUEST"] = "GET_BASKET_DETAILS_REQUEST";
    GET_BASKET_DETAILS["SUCCESS"] = "GET_BASKET_DETAILS_SUCCESS";
    GET_BASKET_DETAILS["ERROR"] = "GET_BASKET_DETAILS_ERROR";
})(GET_BASKET_DETAILS || (GET_BASKET_DETAILS = {}));
function fetchCartDetailsFactory(requestAction, successAction, errorAction, view = CartView.ALL) {
    return function (pincode = '', error) {
        const pathname = '/api/5/cart';
        let query = { view };
        pincode && (query.pincode = pincode);
        error && (query.error = error);
        return (dispatch) => {
            dispatch({
                type: requestAction
            });
            return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
                pathname,
                query,
                acceptErrors: true,
                action: requestAction
            })).then(data => {
                const newPincode = get(data.RESPONSE, [
                    'cartDetails',
                    'cartSummary',
                    'pincode'
                ]);
                dispatch(updatePincodeAction(newPincode));
                return dispatch({
                    type: successAction,
                    data: data.RESPONSE
                });
            }, err => {
                dispatch({
                    type: errorAction,
                    error: err
                });
                return Promise.reject(err);
            });
        };
    };
}
export const fetchCartDetails = fetchCartDetailsFactory(GET_CART_DETAILS.REQUEST, GET_CART_DETAILS.SUCCESS, GET_CART_DETAILS.ERROR, CartView.ALL);
export const fetchBasketDetails = fetchCartDetailsFactory(GET_BASKET_DETAILS.REQUEST, GET_BASKET_DETAILS.SUCCESS, GET_BASKET_DETAILS.ERROR, CartView.GROCERY);
